import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import {
  CURRENT_RELEASE,
  shouldShowReleaseNotes,
  markReleaseNotesAsSeen,
} from '@/lib/releaseNotes';

export function ReleaseNotesDialog() {
  const { i18n } = useTranslation();
  const hasShownRef = React.useRef(false);

  React.useEffect(() => {
    // Check if we should show the release notes and haven't shown it yet
    if (shouldShowReleaseNotes() && !hasShownRef.current) {
      hasShownRef.current = true;

      // Get the current language, fallback to 'en' if not supported
      const currentLang = ['en', 'zh-HK', 'zh-CN'].includes(i18n.language)
        ? (i18n.language as 'en' | 'zh-HK' | 'zh-CN')
        : 'en';

      const releaseContent = CURRENT_RELEASE.notes[currentLang];
      const buttonText =
        currentLang === 'zh-HK' || currentLang === 'zh-CN' ? '知道了' : 'Got it';

      // Delay to ensure Toaster is mounted
      setTimeout(() => {
        // Show toast with release notes
        toast.custom(
          (t) => (
            <div className="bg-background border rounded-lg shadow-lg p-4 w-72">
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <span className="text-2xl">🎉</span>
                  <div>
                    <div className="font-semibold text-base">{releaseContent.title}</div>
                    {/* <div className="text-xs text-muted-foreground">
                      Version {CURRENT_RELEASE.version} • {CURRENT_RELEASE.date}
                    </div> */}
                  </div>
                </div>
                <ul className="space-y-1.5 text-sm">
                  {releaseContent.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <span className="text-primary mt-0.5">•</span>
                      <span className="flex-1">{item}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => {
                    markReleaseNotesAsSeen();
                    toast.dismiss(t);
                  }}
                  className="w-full bg-primary text-primary-foreground rounded-md px-4 py-2 text-sm font-medium hover:bg-primary/90"
                >
                  {buttonText}
                </button>
              </div>
            </div>
          ),
          {
            duration: Infinity,
            position: 'bottom-right',
          }
        );
      }, 500);
    }
  }, [i18n.language]);

  return null;
}
